var _excluded = ["mainLabelProps", "description", "defaultDescription", "actionProps", "avatarProps", "isDisabled", "selectionProps", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCallback } from 'react';
import { Group } from '../../../containers';
import { forwardRef, useBoolean } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { Checkbox } from '../../selectionAndInputs/Checkbox';
import { Avatar } from '../Avatar';
import { Typography } from '../typography';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AvatarWithDetails = forwardRef((_ref, ref) => {
  var {
    mainLabelProps,
    description,
    defaultDescription,
    actionProps,
    avatarProps,
    isDisabled,
    selectionProps,
    'data-testid': dataTestId = 'avatar-with-details'
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var [isAvatarHover, setIsAvatarHover] = useBoolean(false);
  var styles = useMultiStyleConfig('AvatarWithDetails', {
    isAvatarHover,
    isSelected: selectionProps === null || selectionProps === void 0 ? void 0 : selectionProps.isSelected
  });
  var desc = description || defaultDescription;
  var handleAvatarHover = useCallback(isHover => {
    if (!selectionProps) return;

    if (isHover) {
      setIsAvatarHover.on();
    } else {
      setIsAvatarHover.off();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    "data-testid": dataTestId
  }, rest), {}, {
    __css: styles['container'],
    "data-component": "AvatarWithDetails",
    ref: ref,
    children: [/*#__PURE__*/_jsxs(Box, {
      "aria-disabled": isDisabled,
      onMouseOver: () => handleAvatarHover(true),
      onMouseOut: () => handleAvatarHover(),
      __css: styles['avatarContainer'],
      "data-testid": "".concat(dataTestId, "-avatar-container"),
      children: [/*#__PURE__*/_jsx(Box, {
        __css: styles['avatar'],
        children: /*#__PURE__*/_jsx(Avatar, _objectSpread(_objectSpread({}, avatarProps), {}, {
          isDisabled: isDisabled
        }))
      }), selectionProps && /*#__PURE__*/_jsx(Box, {
        __css: styles['checkbox'],
        children: /*#__PURE__*/_jsx(Checkbox, {
          onChange: () => selectionProps.onSelect(selectionProps.isSelected),
          isChecked: selectionProps.isSelected,
          isDisabled: isDisabled
        })
      })]
    }), /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      spacing: "xxs",
      children: [/*#__PURE__*/_jsx(Typography.MainLabel, _objectSpread(_objectSpread({}, mainLabelProps), {}, {
        variant: "bold",
        isDisabled: isDisabled
      })), desc && /*#__PURE__*/_jsx(Typography.Description, {
        label: desc,
        isDisabled: isDisabled,
        action: actionProps,
        link: undefined
      })]
    })]
  }));
});
AvatarWithDetails.displayName = 'AvatarWithDetails';
//# sourceMappingURL=AvatarWithDetails.js.map